import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`The `}<a parentName="p" {...{
        "href": "/react-sim/api#default-timer"
      }}>{`Default timer`}</a>{` properties, plus:`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td">{`maxTime`}</strong><br />{`integer, 100 by default`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`At which position the timer ends.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td">{`minTime`}</strong><br />{`integer, 0 by default`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`At which position the timer starts. Can be negative.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td">{`label`}</strong><br />{`string, optional`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The label which will describe the control.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td">{`name`}</strong><br />{`string, optional`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The name of the control. If not specified, label is used.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td">{`shouldDisplayLabel`}</strong><br />{`boolean, default true`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Whether the label should be displayed.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td">{`shouldDisplayMaxValue`}</strong><br />{`boolean, default true`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Whether the maximum value should be displayed to the right of the range.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td">{`shouldDisplayMinValue`}</strong><br />{`boolean, default true`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Whether the minimum value should be displayed to the left of the range.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td">{`shouldDisplayValue`}</strong><br />{`boolean, default true`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Whether the value should be displayed next to the label.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td">{`showTime`}</strong><br />{`boolean, true by default`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Whether the time block (i.e. slider and time value) is going to be shown.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td">{`showTimeSlider`}</strong><br />{`boolean, true by default`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Whether the time slider is going to be shown.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td">{`time`}</strong><br />{`number`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The current value of time shown on this Timer`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td">{`updateTime`}</strong><br />{`function`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The function that will update this Timer's time when the`}</td>
        </tr>
      </tbody>
    </table>
    <p>{`Unlike the other built-in controls, Timer does `}<em parentName="p">{`not`}</em>{` take a `}<inlineCode parentName="p">{`value`}</inlineCode>{` or a `}<inlineCode parentName="p">{`setValue`}</inlineCode>{` parameter.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      